import { Button, Form, Input, Modal, Space } from 'antd';
import React, { useEffect } from 'react';
import { CloseCircle } from '../../../assets/svg';

const CreateSenderModal = ({
  isModalOpen,
  setIsModalOpen,
  initialValues,
  formTitle,
  formItems,
  onFinish,
  onUpdate,
  isEdit,
  setIsEdit,
  setIsEditSenderRowData,
  submitButton,
  loadings,
  form,
  handleReset
}) => {
  useEffect(() => {
    form?.setFieldsValue(initialValues);
  }, [form, initialValues]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setIsEditSenderRowData({});
    setTimeout(handleReset, 500);
  };

  return (
    <>
      <Modal
        centered
        wrapClassName="environment-modal sender-modal"
        visible={isModalOpen}
        onCancel={handleCancel}
        closeIcon={<CloseCircle />}
        footer={null}
        onOk={form?.submit}
        forceRender
      >
        <Form
          form={form}
          onFinish={isEdit ? onUpdate : onFinish}
          autoComplete="off"
          layout="vertical"
          validateTrigger="onBlur"
        >
          <div className="add-container">
            <div className="d-flex flex-horizontal justify-between">
              <p className="add-title">{formTitle}</p>
            </div>
            <div className="d-flex flex-vertical justify-between ">
              {formItems?.length > 0 &&
                formItems?.map((formItem) => {
                  return (
                    <Form.Item
                      key={formItem?.name}
                      label={formItem?.title}
                      name={formItem?.name}
                      rules={formItem?.rules}
                    >
                      <Input
                        className="input-box"
                        placeholder={formItem?.placeholder}
                        maxLength={formItem?.maxLength}
                        disabled={formItem?.name === 'email' && isEdit}
                      />
                    </Form.Item>
                  );
                })}
            </div>
            <Space size="middle" className="mt-20 ">
              <Button
                type="primary"
                htmlType="submit"
                className="primary-button"
                loading={loadings}
              >
                {submitButton}
              </Button>
              <Button
                className="secondary-button"
                onClick={() => {
                  handleCancel();
                }}
              >
                Cancel
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default CreateSenderModal;
